import { ref } from 'vue'
import { createGlobalState } from '@vueuse/core'
import { fetchApiData } from '@/vue/helpers/getApiData'
import type { Currency } from '@/vue/pages/roadmap/components/types'

const useCurrencies = createGlobalState(() => {
    const currencies = ref<Currency[]>([])

    async function fetchCurrencies() {
        // Skip if already loaded (global state persists across mounts)
        if (currencies.value.length > 0) {
            return
        }
        const { data } = await fetchApiData<{ data: { data: Currency[] } }>('/api/currencies')
        currencies.value = data?.data.data || []
    }

    fetchCurrencies()

    return { currencies }
})

export default useCurrencies
